import React, { FunctionComponent } from 'react';

interface IProps {
  active?: boolean;
  fallback?: JSX.Element;
}
export const FeatureFlag: FunctionComponent<IProps> = ({ active, fallback, children }) =>
  active ? <>{children}</> : <>{fallback}</>;
